import React, { useState, useContext } from "react";
import { IResetPasswordModel } from "@Models/ILoginDetails";
import "@Styles/main.scss";
import AccountService from "@Services/AccountService";
import PasswordResetRequestForm from "@Components/account/PasswordResetRequestForm";
import PageHelmet from "@Components/shared/PageHelmet";
import { Alert } from "antd";
import { useHistory } from "react-router-dom";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";

/**
 * Page to request a password reset
 * @param props
 * @constructor
 */
const ResetPasswordPage: React.FC = (props) => {
    const [resetMessage, setResetMessage] = useState<boolean>(false);
    const [fetching, setFetching] = useState<boolean>(false);
    const history = useHistory();
    const { ui: uiState } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;

    const onResetSubmit = async (data: IResetPasswordModel) => {
        setFetching(true);
        const service = new AccountService();
        await service.reset(data);
        setResetMessage(true);
        setFetching(false);
    };

    const onBackSelect = () => {
        history.push("/login");
    };

    return (
        <section
            id="reset-password-page"
            style={
                isDesktop ? { display: "flex", alignItems: "center", justifyContent: "center", height: "100%" } : null
            }
        >
            <PageHelmet name={"Reset Password"} />
            <PasswordResetRequestForm
                {...props}
                onResetSubmit={onResetSubmit}
                onBackSelect={onBackSelect}
                fetching={fetching}
            />

            {resetMessage && (
                <>
                    <div className={"spacer"}>&nbsp;</div>
                    <Alert
                        message={"Thanks. We've sent a password reset to the email you've provided."}
                        type="info"
                        showIcon
                    />
                </>
            )}
        </section>
    );
};

export default ResetPasswordPage;
